import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import { AdminPage } from './pages/admin';
import { DistributionListsPage } from './pages/distribution-lists';
import { EmailTemplatesPage } from './pages/email-templates';
import { OrganizationUnitListsPage } from './pages/organization-unit-lists';
import { TargetGroupsPage } from './pages/target-groups';
import { TopicsPage } from './pages/topics';
import { UsersPage } from './pages/users';
import { DashboardPage } from './pages/dashboard';
import { DraftRegulationPage } from './pages/draft-regulation';
import { RegulationPage } from './pages/regulation';
import { NotFoundPage } from './pages/not-found';

import AdminRoute from './utils/AdminRoute.tsx';

import { RawRegulationsPage } from './pages/raw-regulations';

function App() {
  return (
    <Router>
      <Routes>
        <Route element={<DashboardPage />} path="/" />
        <Route
          element={
            <AdminRoute>
              <AdminPage />
            </AdminRoute>
          }
          path="/admin"
        />
        <Route
          element={
            <AdminRoute>
              <DistributionListsPage />
            </AdminRoute>
          }
          path="/admin/distribution-lists"
        />
        <Route
          element={
            <AdminRoute>
              <EmailTemplatesPage />
            </AdminRoute>
          }
          path="/admin/email-templates"
        />
        <Route
          element={
            <AdminRoute>
              <OrganizationUnitListsPage />
            </AdminRoute>
          }
          path="/admin/organization-unit-lists"
        />
        <Route
          element={
            <AdminRoute>
              <TargetGroupsPage />
            </AdminRoute>
          }
          path="/admin/target-groups"
        />
        <Route
          element={
            <AdminRoute>
              <TopicsPage />
            </AdminRoute>
          }
          path="/admin/topics"
        />
        <Route
          element={
            <AdminRoute>
              <UsersPage />
            </AdminRoute>
          }
          path="/admin/users"
        />
        <Route
          element={
            <AdminRoute>
              <RawRegulationsPage />
            </AdminRoute>
          }
          path="/admin/raw-regulations"
        />
        <Route element={<DraftRegulationPage />} path="/regulation/draft" />
        <Route element={<DraftRegulationPage />} path="/regulation/draft/:id" />
        <Route element={<DraftRegulationPage />} path="/regulation/draft/view/:id" />
        <Route element={<RegulationPage />} path="/regulation" />
        <Route element={<RegulationPage />} path="/regulation/:id" />
        <Route element={<RegulationPage />} path="/regulation/:id/request-deletion" />
        <Route element={<RegulationPage />} path="/regulation/edit/:id" />
        <Route element={<NotFoundPage />} path="/not-found" />
        <Route element={<NotFoundPage />} path="*" />
      </Routes>
    </Router>
  );
}

export default App;
